import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const GatewayIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.9725 6.16697C17.6256 5.32901 17.0379 4.61277 16.2838 4.10884C15.5298 3.60491 14.6432 3.33594 13.7362 3.33594C12.8293 3.33594 11.9427 3.60491 11.1887 4.10884C10.4346 4.61277 9.84695 5.32901 9.5 6.16697"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M16.1437 7.21974C15.9918 6.70092 15.6758 6.24531 15.2431 5.92119C14.8104 5.59706 14.2844 5.42188 13.7438 5.42188C13.2031 5.42188 12.6771 5.59706 12.2444 5.92119C11.8117 6.24531 11.4957 6.70092 11.3438 7.21974"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.82292 13.3333C5.82292 13.5543 5.73512 13.7663 5.57884 13.9226C5.42256 14.0789 5.2106 14.1667 4.98958 14.1667C4.76857 14.1667 4.55661 14.0789 4.40033 13.9226C4.24405 13.7663 4.15625 13.5543 4.15625 13.3333C4.15625 13.1123 4.24405 12.9004 4.40033 12.7441C4.55661 12.5878 4.76857 12.5 4.98958 12.5C5.2106 12.5 5.42256 12.5878 5.57884 12.7441C5.73512 12.9004 5.82292 13.1123 5.82292 13.3333ZM8.32292 13.3333C8.32292 13.5543 8.23512 13.7663 8.07884 13.9226C7.92256 14.0789 7.7106 14.1667 7.48958 14.1667C7.26857 14.1667 7.05661 14.0789 6.90033 13.9226C6.74405 13.7663 6.65625 13.5543 6.65625 13.3333C6.65625 13.1123 6.74405 12.9004 6.90033 12.7441C7.05661 12.5878 7.26857 12.5 7.48958 12.5C7.7106 12.5 7.92256 12.5878 8.07884 12.7441C8.23512 12.9004 8.32292 13.1123 8.32292 13.3333Z"
        fill="currentColor"
      />
      <path
        d="M1.65625 13.3333C1.65625 11.7617 1.65625 10.9767 2.14458 10.4883C2.63292 10 3.41792 10 4.98958 10H14.9896C16.5612 10 17.3462 10 17.8346 10.4883C18.3229 10.9767 18.3229 11.7617 18.3229 13.3333C18.3229 14.905 18.3229 15.69 17.8346 16.1783C17.3462 16.6667 16.5612 16.6667 14.9896 16.6667H4.98958C3.41792 16.6667 2.63292 16.6667 2.14458 16.1783C1.65625 15.69 1.65625 14.905 1.65625 13.3333Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M13.75 10V7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </BaseIcon>
  );
};

GatewayIcon.displayName = 'GatewayIcon';
